module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABTSURBVHgB7ZXRCUAhCEXvexM0WiM0QhvUJq3SZmYb3ODSR3jAD0EOKIoAiZklpu4HT3bpgBIXtpCGFPh2Ag3FY54s9j28yy6bY8gek1XpibEvYAHO03kIjXLW5wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/goto2.png
// module id = 8j51
// module chunks = 1